module.exports = __webpack_public_path__ + "static/media/mainLogo.7f049785.svg";